import styled, { css } from 'styled-components';

export const ModalContent = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    color: ${theme.v2.colors.neutral.lowDark};
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }  
  `}
`;

export const ModalActions = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;
    text-wrap-mode: nowrap;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column-reverse;
      width: 100%;
    }
  `}
`;

export const AlertBox = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.feedback.pendingUltraLight};
    border-left: 4px solid ${theme.v2.colors.feedback.pendingMedium};
    border-radius: 4px;
    padding: 16px;
    margin: 0;
    display: flex;
    align-items: flex-start;
    gap: 8px;    
  `}
`;

export const AlertBoxContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const AlertBoxTitle = styled.h4`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: ${theme.v2.font.lineHeight.text};
    color: ${theme.v2.colors.feedback.pendingMedium};
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const AlertBoxMessage = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    color: ${theme.v2.colors.neutral.lowDark};
    margin: 0;

    a {
      font-size: inherit;
    }
  `}
`;

export const InputsWrapper = styled.div`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;  
`;

export const CheckboxLabel = styled.label`
  ${({ theme }) => css`
    cursor: pointer;
    display: inline-flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 8px;
    margin: 0;

    button {
      padding: 3px 0 0 0;
    }    

    label {
      width: 16px;
      height: 16px;
      border-radius: 4px;
      border: 1px solid ${theme.v2.colors.neutral.lowLight};

      svg {
        fill: ${theme.v2.colors.neutral.highPure};
        stroke: ${theme.v2.colors.neutral.highPure};
        flex: 0 0 12px;
        border-radius: 4px;
      }      
    }

    input:checked ~ label {
      background-color: ${theme.v2.colors.brand.primaryMedium};
      border-color: ${theme.v2.colors.brand.primaryMedium} !important;
    }    
  `}
`;

export const Text = styled.span`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    color: ${theme.v2.colors.neutral.lowDark};
    margin: 0; 
    user-select: none;

    a {
      font-size: inherit;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }    
  `}
`;
